<ng-template #modalConfirmDelete let-c="close" let-d="dismiss">
  <wsb-modal
    cancelButtonEnable="true"
    cancelButtonText="{{ 'common_cancel' | translate }}"
    primaryButtonText="{{ 'common_ok' | translate }}"
    (primary)="closeDelete()"
    (dismiss)="d()"
  >
    <div body>
      <div translate>smsadv_delete_confirm</div>
    </div>
  </wsb-modal>
</ng-template>

<wsb-atlas-grid
  #grid
  class="atlas-grid-simplest"
  class="mt-2"
  [columnDefs]="tableColumnsDefs"
  [options]="tableGridOptions"
  [rowData]="tableRowData"
  [components]="components"
  [@gridIsLoaded]="gridAnimationState"
>
</wsb-atlas-grid>
